// @sonar-ignore
import styled from '@emotion/styled';
import { css } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { getThemeColor } from '@ezugi/ui/theme';
import { DeviceInfo } from '@ezugi/utils';

const CHIP_BORDER_WIDTH = 1;
const CHIP_SCALE = 1;
const SELECTED_CHIP_BORDER_WIDTH = 2;
const SELECTED_CHIP_SCALE = 1.2;
const TRANSITION_TIME = 0.2;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
`;

export const Backdrop = styled.div`
  position: absolute;
  background: radial-gradient(#000 0%, rgba(0,0,0,0.5) 30%, rgba(0,0,0,0) 70%);
  border-radius: 50%;
  transition: all ${TRANSITION_TIME}s linear;
`;

export const selectedChip = css`
  transform: scale(${SELECTED_CHIP_SCALE});
  ${!DeviceInfo.isHandheld ? `
    border: ${SELECTED_CHIP_BORDER_WIDTH}px solid white;
    box-shadow: 0px 0px 20px #ECC971;
  ` : ''}
`;

const commonPseudoElementStyles = css`
  content: "";
  position: absolute;
  border-radius: 50%;
`;

const handheldStyles = css`
  transform: scale(1.3);

  &.open::before {
    ${commonPseudoElementStyles}
    background: #000;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    z-index: -1;
  }

  &.open::after {
    ${commonPseudoElementStyles}
    background: linear-gradient(50deg, #F7EAA3, #C29740, #FEF8B9);
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    z-index: -2;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.5);
  }
`;

const nonHandheldStyles = css`
  border: ${SELECTED_CHIP_BORDER_WIDTH}px solid white;
  box-shadow: none;

  &::before {
    ${commonPseudoElementStyles}
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: ${getThemeColor('felt')};
    z-index: -1;
  }

  &::after {
    ${commonPseudoElementStyles}
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    background: linear-gradient(50deg, #F7EAA3, #C29740, #FEF8B9);
    z-index: -2;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.5);
  }
`;

export const selectedEvoChip = css`
  transform: scale(1);
  ${!DeviceInfo.isHandheld ? nonHandheldStyles : handheldStyles}
`;

export const nextToSelectedEvoChip = css`
    right: -11px;
    display: block;
`;

export const prevToSelectedEvoChip = css`
    display: block;
    left: -11px;
`;

export const ChipContainer = styled.div<{disabled?: boolean}>`
  position: relative;
  display: inline-block;
  transition: all ${TRANSITION_TIME}s linear;
  transform: scale(${CHIP_SCALE});
  margin-right: ${(SIZES.CHIP_SIZE / 10) * 2 - SELECTED_CHIP_BORDER_WIDTH}px;
  border: ${SELECTED_CHIP_BORDER_WIDTH}px solid transparent;
  border-radius: 50%;
  flex: none;
  font-size: 0;
  box-shadow: none;
  letter-spacing: -0.1px;

  &:last-child {
    margin-right: 0;
  }

  ${({ disabled }) => (!disabled && `
    &:hover {
      ${selectedChip};
    }
  `)}
`;

export const radialChipHighlight = css`
  border: ${CHIP_BORDER_WIDTH}px solid white;
`;

export const radialChipContainer = css`
  position: absolute;
  transition: transform ${TRANSITION_TIME}s cubic-bezier(.76,.45,.43,1.33);
  will-change: transform;
  margin: 0;
  margin-right: 0;
  box-shadow: inset 0px 2px 1px rgba(255, 255, 255, 0.25);
  border: ${CHIP_BORDER_WIDTH}px solid transparent;

  &:hover {
    ${radialChipHighlight};
  }
`;

export const selectedRadialChip = css`
  ${selectedChip};
  top: 2px;

  &:active {
    transform: scale(${CHIP_SCALE});
  }

  @media all and (orientation: landscape) and (max-height: 300px) {
    top: 0;
    transform: scale(1.05);
  }
`;

export const cashierBtn = css`
  opacity: 0;

  &.open {
    box-shadow: none;
    opacity: 1;
  }
`;
